import { baseURL, moduleName } from "../../../controllers/api/globalEndpoint.api";

const publicViewEndPoint = {
    getPublicViewDetails: baseURL + moduleName.publicApi + '/get-chatbot-public-view-data/',
    createNewConversation: baseURL + moduleName.publicApi + '/chatbot-sent-reply',
};
export default publicViewEndPoint;


